<script>
import Loading from 'components/elements/Loading.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';

import FormCard from 'components/elements/FormCard.svelte';




import SvelteSeo from 'svelte-seo';


const forms = [
	{
		name: 'Selects & Young Guns Fundraising Form',
		id: 'selects-young-guns-fundraising',
	},
	// {
	// 	name: '2023 Spring Jersey Sponsor Form',
	// 	id: 'team-instance-jersey-sponsor-order/1'
	// },
	// {
	// 	name: '2021 - 2022 Adult Hockey Free Agent Form',
	// 	id: 'adult-hockey-free-agent/2',
	// },
	// {
	// 	name: '2023 Spring Hockey Free Agent Form',
	// 	id: 'spring-hockey-free-agent/2'
	// },
];


</script>


<style>
	

</style>



<SvelteSeo
	title='Forms | AHG Forms'
	description='Forms!'
/>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Forms
			</p>

		</div>

	</div>
	
</section>



<section class="section">

	<div class="container is-fullwidth">

		<div class="columns is-centered">

			<div class="column is-9-desktop is-10-tablet is-12-mobile">

				{#if forms.length === 0}

				<MsgCard msg_show={true} msg_text={'There are no forms active!'} msg_type={'error'} msg_forever={true} />

				{:else}

				<div class="columns is-variable is-3 is-mobile is-multiline is-centered">

					{#each forms as form}

						<div class="column is-6-desktop is-12-touch">

							<FormCard {form} />

						</div>

					{/each}

				</div>

				{/if}

			</div>

		</div>

	</div>

</section>

<!-- email: donotreply@atlantichockeygroup.com -->

